<template>
  <div :key="imageSkeletonKey" class="product-image-skeleton">
    <!-- Image -->
    <AtomicUiSkeleton width="100%" height="auto" :style="imageSkeletonStyle" />
  </div>
</template>

<script setup>
const imageSkeletonKey = ref(1);

const imageSkeletonStyle = {
  'aspect-ratio': '0.8',
};

onMounted(() => {
  imageSkeletonKey.value += 1;
});
</script>
